import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { JobScreenInspectionContacts } from '../../../../interfaces/screen-specific/job-screen/common/job-screen-inspection-contacts';
import { TaskService } from '../../../../services';

@Component({
  selector: 'job-screen-inspection-contacts',
  templateUrl: './job-screen-inspection-contacts.component.html',
  styleUrls: ['./job-screen-inspection-contacts.component.css'],
})
export class JobScreenInspectionContactsComponent implements OnChanges {
  @Input('taskId') taskId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  inspectionContacts: JobScreenInspectionContacts;
  loading: boolean = false;

  constructor(private taskService: TaskService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskId) {
      this.fetchContacts(this.taskId).then(() => {});
    }
  }

  async fetchContacts(taskId: number) {
    this.loading = true;
    return this.taskService
      .getForComponent(taskId, 'job-screen-inspection-contacts')
      .then((contacts: JobScreenInspectionContacts) => {
        this.inspectionContacts = contacts;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
